import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SalesRoleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 9H21"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.92529 16.8891C5.94808 17.0535 5.99284 17.1764 6.05957 17.2578C6.18164 17.4059 6.39079 17.48 6.68701 17.48C6.86442 17.48 7.00846 17.4604 7.11914 17.4214C7.3291 17.3465 7.43408 17.2073 7.43408 17.0039C7.43408 16.8851 7.382 16.7931 7.27783 16.728C7.17367 16.6645 7.01009 16.6084 6.78711 16.5596L6.40625 16.4741C6.0319 16.3895 5.77311 16.2975 5.62988 16.1982C5.38737 16.0322 5.26611 15.7726 5.26611 15.4194C5.26611 15.0972 5.3833 14.8294 5.61768 14.6162C5.85205 14.403 6.19629 14.2964 6.65039 14.2964C7.02962 14.2964 7.3527 14.3973 7.61963 14.5991C7.88818 14.7993 8.02897 15.0906 8.04199 15.4731H7.31934C7.30632 15.2567 7.21191 15.1028 7.03613 15.0117C6.91895 14.9515 6.77327 14.9214 6.59912 14.9214C6.40544 14.9214 6.25081 14.9604 6.13525 15.0386C6.01969 15.1167 5.96191 15.2257 5.96191 15.3657C5.96191 15.4943 6.01888 15.5903 6.13281 15.6538C6.20605 15.6961 6.3623 15.7458 6.60156 15.8027L7.22168 15.9516C7.49349 16.0167 7.69857 16.1038 7.83691 16.2129C8.05176 16.3821 8.15918 16.6271 8.15918 16.9477C8.15918 17.2765 8.03304 17.55 7.78076 17.7681C7.53011 17.9845 7.17529 18.0928 6.71631 18.0928C6.24756 18.0928 5.87891 17.9862 5.61035 17.7729C5.3418 17.5581 5.20752 17.2635 5.20752 16.8891H5.92529Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path
                d="M9.69971 16.6401H10.6128L10.1636 15.2241L9.69971 16.6401ZM9.74609 14.4014H10.5957L11.8701 18H11.0547L10.8228 17.2602H9.49707L9.24805 18H8.46191L9.74609 14.4014Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path d="M12.3291 14.4014H13.0811V17.353H14.8633V18H12.3291V14.4014Z" fill={props.htmlColor || '#21272E'} />
            <path
                d="M18.0469 15.0386H16.1426V15.8027H17.8906V16.4277H16.1426V17.353H18.1348V18H15.4077V14.4014H18.0469V15.0386Z"
                fill={props.htmlColor || '#21272E'}
            />
        </SvgIcon>
    );
};
